import { ApiFactory, type ApiDataResponse } from '@/utils/api';

const baseUrl: string = import.meta.env.VITE_FUNDAY_API_URL;

export class ClassNotifyService extends ApiFactory {
  constructor() {
    super(`${baseUrl}`);
  }

  /**
   * 通知顧問 免費會員想上課 (後端寄送 Email)
   * @param classId - 課程編號
   * @remarks
   * - 信件內容 (會員名稱、日期時間、課程名稱) 由後端依 Token 與 classId 組出
   * - 背景通知，關閉全域 loading 與錯誤 toast，避免干擾原本的上課流程
   */
  createAttendClassNotify(classId: string): Promise<ApiDataResponse<boolean>> {
    return super.post(
      `v2/ClassNotify/AttendClass`,
      { classId },
      {
        headers: {
          'Content-Type': 'application/json',
          disableGlobalLoading: true,
          'X-Silent-Error': 'true'
        }
      }
    );
  }
}
